import { useMemo, type ReactElement } from 'react';
import { usePageBreadcrumb, usePageSidebar, useStrapiApi } from '@/hooks';
import { sidebarItems } from './sidebar';
import type { PaginaData } from '@/interfaces/strapi';
import { getPage } from '@/services/strapi';
import { ROUTES } from '@/constants';
import { useParams } from 'react-router-dom';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

export const ActuacionNotarialPage = (): ReactElement => {
	const { page: pageSlug } = useParams<{ page: string }>();

	const {
		loading: loadingPage,
		data: page,
		error: errorPage,
	} = useStrapiApi<PaginaData | null, string>(getPage, {
		autoFetch: true,
		params: pageSlug,
	});

	usePageBreadcrumb([
		{ label: 'Información', to: ROUTES.INFORMACION_BUSCADOR_NOTARIOS },
		{
			label: 'Nuevas Actuaciones notariales',
			to: ROUTES.INFORMACION_NUEVAS_ACTUACIONES_NOTARIALES,
		},
		{ label: page?.title ?? '' },
	]);

	const sidebar = useMemo(() => sidebarItems, []);
	usePageSidebar(sidebar, true);

	if (loadingPage) return <div className="u-mt-md">Cargando…</div>;
	if (errorPage) return <div className="u-mt-md">No se pudo cargar la página.</div>;
	if (!page) return <div className="u-mt-md">No se encontró la página.</div>;

	return <div className="o-strapi-page">{page.body && <BlocksRenderer content={page.body as any} />}</div>;
};
